'use client';

import { Suspense, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import styles from './Header.module.scss';
import { UnivoImage } from '@/components/common';
import StudentLoginModal from './StudentLoginModal';

function JioPCLogo() {
  const searchParams = useSearchParams();
  const isRelind = searchParams.get('PaymentEntity') === 'RELIND';
  const src = isRelind ? '/_a/icons/reliance_jiopc.svg' : '/_a/icons/JPC.svg';
  const width = isRelind ? 69 : 129;
  return <UnivoImage src={src} alt="JIO PC Logo" width={width} height={48} isLcp className={styles.amityLogo} />;
}

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <header className={styles.header} id="header_new">
        <div className={styles.inner}>
          <div className="flex items-center gap-4">
            <UnivoImage
              src="https://static.amityonline.com/_s/amity_logo_c_white_ffbfeced80.svg"
              alt="Amity University Online"
              width={122}
              height={40}
              isLcp
              className={styles.amityLogo}
            />

            <span className={styles.divider} aria-hidden="true" />

            <div className="flex items-center gap-2">
              <Suspense fallback={<UnivoImage src="/_a/icons/JPC.svg" alt="JIO PC Logo" width={129} height={48} isLcp className={styles.amityLogo} />}>
                <JioPCLogo />
              </Suspense>
            </div>
          </div>

          <button
            className={`${styles.loginBtn} flex items-center gap-2`}
            type="button"
            onClick={() => setIsOpen(true)}
          >
            <UnivoImage src="/_a/icons/login_user.svg" alt="" width={16} height={16} aria-hidden="true" />
            Student Login
          </button>
        </div>
      </header>

      {isOpen && <StudentLoginModal onClose={() => setIsOpen(false)} />}
    </>
  );
}
